/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useState } from 'react';

import './animation008.less';
import ImgPoint from '../../../../../assets/animation_point.gif';
import arrow from '../../../../../assets/arrow.png';

import { Button, Modal } from 'antd';

interface IAnimation008SubItem {
  img: string;
  title: string;
}

interface IAnimation008Item {
  icon?: string;
  title: string;
  subtitle?: string;
  content: [];
  tip?: string;
  subItems?: IAnimation008SubItem[];
}

const bgTemplate = [
  '#597EF7',
  '#0CA3A3',
  '#F26927',
  '#E7444E',
  '#EF878D',
  '#2C2281',
  '#E7444E',
  '#FFC53D',
  '#0CA3A3',
  '#0C53A3',
];

const getImg = (img: string) => require(`../../../../../assets/${img}`).default;

const getBG = (feed: number) => bgTemplate[feed % bgTemplate.length];

interface IAnimation008Props {
  items: IAnimation008Item[];
  style?: React.CSSProperties;
  title?: string | null;
  onCompleted?: () => void;
  className?: string;
}

const Animation008: React.FunctionComponent<IAnimation008Props> = ({
  className,
  title,
  items,
  style,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      onCompleted && onCompleted();
    }
  };

  const rowCount = items.length <= 5 ? items.length : 5;

  const [isModalOpen, setModalOpen] = useState(false);

  const [modalItem, setModalItem] = useState<IAnimation008SubItem[]>();

  const [show, setShow] = useState(true);

  return (
    <div
      ref={crrRef}
      className={`animation008 component ${className}`}
      style={{ margin: 0 }}
    >
      {title && (
        <div
          className="animation008-title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      <div className="animation008-content">
        {items.map((itm: IAnimation008Item, idx: number) => (
          <div
            key={idx}
            className={`animation008-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => startPlay()}
            style={{
              width: `calc(${(1 / rowCount) * 100}% - 1rem)`,
              backgroundColor: getBG(idx),
            }}
          >
            <img
              className={`click-point ${play > 1 ? 'hide' : ''}`}
              src={ImgPoint}
              alt=""
            />
            <div className="animation008-header">
              <div className="subtitle">
                {itm.subtitle}
                <div className={`arrow r${idx + 1}`}>
                  <img src={arrow} alt="" />
                </div>
              </div>
            </div>
            {itm.icon && (
              <div className={`small-icon ${!itm.title ? 'large' : ''}`}>
                <img src={getImg(itm.icon)} alt="" />
              </div>
            )}
            {itm.title && (
              <div
                className="animation008-top"
                dangerouslySetInnerHTML={{ __html: itm.title }}
              />
            )}
            <div className="animation008-text">
              <ul>
                {itm.content.map((itms: string, idxs: number) => (
                  <div
                    className="animation008-content"
                    key={idxs}
                    dangerouslySetInnerHTML={{ __html: itms }}
                  />
                ))}
              </ul>
              {itm.subItems ? (
                <div>
                  <Button
                    className="view-more-btn"
                    onClick={() => {
                      setModalItem(itm.subItems);
                      setModalOpen(true);
                      setShow(false);
                    }}
                    type="link"
                  >
                    {itm.tip}
                    <img
                      className="click-point1"
                      hidden={!show}
                      src={ImgPoint}
                      alt=""
                    />
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>
      {modalItem && (
        <Modal
          width="60%"
          className="animation008-modal"
          title={
            <div className="animation008-modal-header">
              <div className="animation008-modal-title">
                {modalItem[0]?.title}
              </div>
            </div>
          }
          footer={null}
          visible={isModalOpen}
          onCancel={() => setModalOpen(false)}
        >
          <img
            src={require(`../../../../../assets/${modalItem[0]?.img}`).default}
            alt=""
          />
        </Modal>
      )}
    </div>
  );
};

Animation008.defaultProps = {
  style: {},
  title: null,
};

export default Animation008;
